/**
 * Map the recognized page content types.
 */
export default [
  'HomePage',
  'ActivityIndex',
  'ActivityPage',
  'CustomActivityPage',
  'SimpleContentPage',
  'LegalPage',
  'NewsIndex',
  'NewsPage',
  'AudienceSplitPage',
  'ServiceIndex',
  'AccommodationIndex',
  'ServicePage',
  'PartnerHomepage',
  'ScheduleOverviewPage',
];
